// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CanonicalAddress,
} from "./types";


export default __t.row({
  id: __t.uuid(),
  brand: __t.uuid(),
  googlePlaceId: __t.option(__t.string()).name("google_place_id"),
  googlePlacePhotoName: __t.option(__t.string()).name("google_place_photo_name"),
  imageUrl: __t.option(__t.string()).name("image_url"),
  externalId: __t.option(__t.string()).name("external_id"),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  sqft: __t.option(__t.f64()),
  get canonicalAddress() {
    return CanonicalAddress.name("canonical_address");
  },
});
